
import styled, { css } from 'styled-components';

const padding = 24;
const paddingListScroll = 16;
export const ListItem = styled.li`
  ${({ $isChecked, theme }) => css`
    background-color: ${$isChecked ? theme.v2.colors.brand.primaryUltraLight : 'transparent'};
    border-bottom: 1px solid ${theme.v2.colors.brand.primaryLowLight};
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: calc(100% - ${2 * padding}px - ${paddingListScroll}px);
    padding: ${padding}px;
  `}
`;

export const NoAvailableListItem = styled(ListItem)`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highLight};
    border-radius: 8px;
    border-width: 2px;
    margin-bottom: 4px;
  `}
`;

export const DomainBlock = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    max-width: 350px;
    overflow: hidden;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex: 1 1 194px;
    }
  `}
`;

export const CheckboxLabel = styled.label``;

export const NoAvailableCheckboxLabel = styled.label`
  ${({ theme }) => css`
    * {
      opacity: 0;
      visibility: hidden;
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      display: none;
    }
  `}
`;

export const DomainName = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.default};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    max-width: 350px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  `}
`;

export const NoAvailableDomainName = styled(DomainName)`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowLight};};
  `}
`;

export const DomainTld = styled.strong`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.default};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const NoAvailableDomainTld = styled(DomainTld)`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowLight};
  `}
`;

export const DomainDescription = styled.span`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.default};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    color: ${theme.v2.colors.neutral.lowDark};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const SelectWrapper = styled.div`
  ${({ theme }) => css`
    display: block;
    max-width: 220px;
    width: 100%;

    span {
      display: inline-flex;
      gap: 8px;
    }

    #optionWrapper {
      > div {
        display: inline-flex;
        gap: 8px;
        width: 100%;
      }
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      max-width: 100%;
      align-items: center;
      justify-content: center;
    }
  `}
`;

export const ValueBlock = styled.div`
  ${({ theme }) => css`
    align-items: flex-end;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 280px;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      max-width: 100%;
    }
  `}
`;

export const NoAvailableValueBlock = styled.div`
  max-width: 342px;
`;

export const ThenLabel = styled.span`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.default};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    color: ${theme.v2.colors.neutral.lowDark};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const RegisterPrice = styled.span`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.default};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowDark};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const DisabledList = styled.ul`
  list-style: none;
  margin: 0px;
  max-width: 872px;
  padding: 0px;
  width: 100%;
`;

export const DisabledListItemHead = styled.li`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const DisabledListItem = styled(DisabledListItemHead)`
  ${({ theme }) => css`
    font-weight: ${theme.v2.font.weights.regular};
    padding-left: 10px;
  `}
`;

export const ProtectIdWrapper = styled.div`
  align-items: center;
  background: linear-gradient(90deg, var(--Colors-Brand-Low-Light, #E7F3FD) 0%, var(--Colors-Neutral-High-Pure, #FFF) 100%);
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding: 16px;
  position: relative;
  width: 100%;

  > label {
    flex: 0 0 44px;
  }
`;

export const Row = styled.div`
  ${({ $noGap }) => css`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: ${$noGap ? 'unset' : '16px'};
    justify-content: flex-start;
    position: relative;
    text-align: left;
    width: 100%;
  `}
`;

export const IconWrapper = styled.div`
  position: absolute;
  right: 16px;
  top: 16px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ProtectIdTitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.default};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const ProtectIdDescription = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.default};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};

    strong {
      color: ${theme.v2.colors.feedback.activeMedium};
      font-weight: ${theme.v2.font.weights.bold};
    }
  `}
`;
